var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8749 19C12.6329 18.3801 12.5 17.7056 12.5 17C12.5 13.9624 14.9624 11.5 18 11.5C19.576 11.5 20.9972 12.1629 22 13.2251V8C22 6.89543 21.1046 6 20 6H13.8284C13.298 6 12.7893 5.78929 12.4142 5.41421L10.5858 3.58579C10.2107 3.21071 9.70201 3 9.17157 3H4C2.89543 3 2 3.89543 2 5V17C2 18.1046 2.89543 19 4 19H12.8749Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 21C20.2091 21 22 19.2091 22 17C22 14.7909 20.2091 13 18 13C15.7909 13 14 14.7909 14 17C14 19.2091 15.7909 21 18 21ZM18.75 15V16.6893L19.5303 17.4697C19.8232 17.7626 19.8232 18.2374 19.5303 18.5303C19.2374 18.8232 18.7626 18.8232 18.4697 18.5303L17.4697 17.5303C17.329 17.3897 17.25 17.1989 17.25 17V15C17.25 14.5858 17.5858 14.25 18 14.25C18.4142 14.25 18.75 14.5858 18.75 15Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFolder);
export default __webpack_public_path__ + "static/media/time-folder.3be3df690f61e579aeeecd010b7adfd5.svg";
export { ForwardRef as ReactComponent };